import React, { useState } from "react";
import { Button, Form, Input } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import toast from "react-hot-toast";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import { jwtDecode } from "jwt-decode";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import "../auth.css";

/* ─── SVG Icons ───────────────────────────────────────────── */

const IconMail = () => (
  <svg className="auth-input-icon" viewBox="0 0 24 24">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const IconLock = () => (
  <svg className="auth-input-icon" viewBox="0 0 24 24">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
  </svg>
);



function Login() {
  const dispatch  = useDispatch();
  const navigate  = useNavigate();
  const [form]    = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      dispatch(showLoading());
      const response = await axios.post("/api/user/login", values);
      dispatch(hideLoading());

      if (response.data.success) {
        toast.success(response.data.message);
        const token   = response.data.data;
        localStorage.setItem("token", token);
        const decoded = jwtDecode(token);
        if (decoded.isAdmin)        navigate("/admin/home", { replace: true });
        else if (decoded.isDoctor)  navigate("/doctor",     { replace: true });
        else if (decoded?.isStaff)  navigate("/staff",      { replace: true });
        else                        navigate("/",           { replace: true });
      } else {
        toast.error(response.data.message);
        if (response.data.redirectTo)
          navigate(response.data.redirectTo, { state: { email: values.email }, replace: true });
      }
    } catch {
      dispatch(hideLoading());
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      {/* Cloud blobs */}
      <div className="auth-cloud auth-cloud-1" />
      <div className="auth-cloud auth-cloud-2" />
      <div className="auth-cloud auth-cloud-3" />

      <div className="auth-card">
        {/* Top icon */}
        <div className="auth-icon-wrap">
  <img
    src="/atantis-logo.png"
    alt="Atlantis Pediatric Hospital"
    className="pp-logo-image"
  />
</div>

        <h1 className="auth-title">Healthwyse</h1>
        <p className="auth-subtitle">
          Appointment Portal<br />Easy Online Consultation Scheduling.
        </p>

        <Form form={form} layout="vertical" onFinish={onFinish} className="auth-form">
          <Form.Item name="email"
            rules={[{ required: true, type: "email", message: "Valid email required" }]}>
            <div className="auth-input-wrap">
              <IconMail />
              <Input placeholder="Email" size="large" />
            </div>
          </Form.Item>

          <Form.Item name="password"
            rules={[{ required: true, message: "Password required" }]}>
            <div className="auth-input-wrap">
              <IconLock />
              <Input.Password
                placeholder="Password"
                size="large"
                iconRender={(v) => v ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
              />
            </div>
          </Form.Item>

          <div className="auth-forgot">
            <Link to="/reset-password">Forgot password?</Link>
          </div>

          <Form.Item>
            <Button htmlType="submit" loading={loading} className="auth-btn">
              {loading ? "Signing in…" : "Get Started"}
            </Button>
          </Form.Item>
        </Form>

        {/* Social sign-in */}
        <div className="auth-divider">
          <div className="auth-divider-line" />
          <span className="auth-divider-text">OR</span>
          <div className="auth-divider-line" />
        </div>
        <p className="auth-prompt">
          Don't have an account? <Link to="/Register">Sign up</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;